import React, { Component } from 'react';
import { Container, Accordion, Icon, Label, Button, Header, Modal} from 'semantic-ui-react';
import { PtInput, PtInputShort, PtInputIcon, PtInputIconWaypoint, EditGeographicPoint } from '../../../grit-utilities';
import 'semantic-ui-css/semantic.min.css';
import '../../../index.css';
import ScrollArea from 'react-scrollbar';
import $ from 'jquery';
import config from '../../../config.json';

/*const waypointstuff = [
    { lat: 46.897753, lng: -96.802437 },
    { lat: 46.897753, lng: -96.802437 },
    { lat: 46.897753, lng: -96.802437 }
];*/

const limitPoints = 23;

export default class Detour extends Component {
    constructor(props){
        super(props)
        const { cpModel } = this.props
        this.state = cpModel
    }
    
    deleteDetour = () =>{
        let finalData = {
            consPlanId: this.state.layerId
        };
        this.props.showspinner(true)
        $.ajax({
            type: 'POST',
            url: `${config.server}\\deleteDetour`,
            contentType: 'application/json',
            data: JSON.stringify(finalData),

            success: (data) => {
				if (data['message'] === "OK"){
                    this.setState({
                        DetourEnd: null,
                        DetourStart: null,
                        DetourrouteLength: 0,
                        DetourDescription: null
                    })
                    this.props.cpModel.detourRoute.DetourStart = null
                    this.props.cpModel.detourRoute.DetourEnd = null
                    this.props.cpModel.detourRoute.DetourDescription = null
                    this.props.clickFunctions.onCancelEdit()
                    this.props.getroutes()
                    this.props.showspinner(false)
                }
                
            },
        });
        
    }

    render() {

     const {onClickDetourStart, onClickDetourEnd, onDetourWaypointPlot} = this.props.clickFunctions;
     const startState = (pos, snapped) => {
        const start = `${pos.lat}, ${pos.lng}`;
        this.setState({ DetourStart: start });
        this.props.cpModel.detourRoute.DetourStart = start;
        if (snapped)
        {
            this.props.cpModel['snapPoint'] = snapped.snapPoint;
        }
        this.props.trackLocationChanged(true);
        this.props.triggerNeedSave();
        };
        const endState = (pos) => {
            const end =  `${pos.lat}, ${pos.lng}`;
            this.setState({ DetourEnd: end });
            this.props.cpModel.detourRoute.DetourEnd = end;
            this.props.trackLocationChanged(true);
            this.props.triggerNeedSave();
        };
        /*const textStyle = {color: 'red', fontSize: '15px'}*/
        



        const waypointState = (pos, id) => {
            console.log('Hello World')
            const {DetourWaypoints} = this.state.detourRoute;
            console.log('%c updated waypoints ', 'color: #5EBA7D');
            console.log(id);
            console.log(pos);
            // eslint-disable-next-line
            DetourWaypoints[id] = [parseFloat(pos.lat), parseFloat(pos.lng) ];
            this.setState({ DetourWaypoints: waypoints });
            this.props.cpModel.detourRoute.DetourWaypoints = waypoints;
            this.props.triggerNeedSave();
        }

        // write out waypoint stuff into the form.
        const waypoints = this.state.detourRoute.DetourWaypoints.map((p) => {
            const key = this.state.detourRoute.DetourWaypoints.indexOf(p);
            let wpDisplayVal = `${p[0]}, ${p[1]}`;
            return (
                <PtInputIconWaypoint key={key}
                    inputColor="pt-intent-primary"
                    disabled={this.props.disabled}
                    icon={<a className="grow pt-icon pt-icon-map-marker" style={{ color: '#106BA3' }}
                        onClick={() => {
                            onDetourWaypointPlot(waypointState, key);
                        }}></a>}
                    button={<button className="pt-button pt-minimal pt-intent-primary pt-icon-cross"
                        onClick={() => { this.removeWaypoint(this.state.detourRoute.DetourWaypoints.indexOf(p)); }}></button>}
                    value={wpDisplayVal}
                    label={"Waypoint " + key}/>
            );
        });
        
        return (
            
            <div>


                <Container>
                <ScrollArea
                speed={1}
                className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                contentClassName="content"
                smoothScrolling={true}>
                    <PtInputIcon inputColor="pt-intent-success"
                        disabled={this.props.disabled}
                        icon={<a className="grow pt-icon pt-icon-map-marker"
                            onClick={() => {
                                onClickDetourStart(startState);
                                if (typeof this.props.clickFunctions.loadConstructionHistory === 'function') {
                                    this.props.clickFunctions.loadConstructionHistory();
                                    this.props.clickFunctions.toggleCPLegend();
                                }
                            }}
                            style={{ color: '#0A6640' }}></a>}
                        value={this.state.detourRoute.DetourStart===null? '0,0':this.state.detourRoute.DetourStart}
                        label="Start Location"
                        edit={<EditGeographicPoint originalCoords={this.state.detourRoute.DetourStart===null? '0,0':this.state.detourRoute.DetourStart} updateCoordinate={(cp) => { onClickDetourStart(startState, cp);  this.props.triggerNeedSave(); }} />}
                    />
                     <PtInputIcon inputColor="pt-intent-warning"
     disabled={this.props.disabled}
     icon={<a className="grow pt-icon pt-icon-map-marker"
         onClick={() => {
            onClickDetourEnd(endState);
             if (typeof this.props.clickFunctions.loadConstructionHistory === 'function') {
                 this.props.clickFunctions.loadConstructionHistory();
                 this.props.clickFunctions.toggleCPLegend();
             }
             
         }}
         style={{ color: '#A66321' }}></a>}
     value={this.state.detourRoute.DetourEnd===null? '0,0':this.state.detourRoute.DetourEnd}
     label="End Location"
     edit={<EditGeographicPoint originalCoords={this.state.detourRoute.DetourEnd===null? '0,0':this.state.detourRoute.DetourEnd} updateCoordinate={(cp) => { onClickDetourEnd(endState, cp);  this.props.triggerNeedSave(); }} />}
      />

      
         <Label color='blue' style={this.state.detourRoute.DetourrouteLength> 0 ? {marginTop: 10 } : { display: 'none' }} basic size='mini'>
             Length: {this.state.detourRoute.DetourrouteLength} Miles
         </Label>
         { this.state.detourRoute.DetourIsPolyLine &&
         <Label color='green' basic size='mini'>Is PolyLine</Label>
     }

 
     <Accordion fluid>
     <Accordion.Title className="accordion-title">
         <Icon name='dropdown' />
         Waypoints
     </Accordion.Title>
     <Accordion.Content>
         <div className="pt-input-group pt_inputIcon_width pt-fill" style={{ height: 40 }}>
             { this.state.detourRoute.DetourWaypoints &&
                 <button type="button" disabled={this.props.disabled}
                     className="pt-button pt-icon-add pt-icon-map-marker pt-intent-primary"
                     onClick={()=>{this.addWaypoint()}}>
                     New Waypoint</button>
             }
         </div>
         {/* Change the below code with a for loop in case of multiple way points. To do a for loop use the map function of javascript*/}
         {waypoints}
     </Accordion.Content>
 </Accordion>

 <PtInput label="Segment Description" disabled={this.props.disabled} value={this.state.detourRoute.DetourDescription===null?"":this.state.detourRoute.DetourDescription} placeholder="Segment Description"
     onChange={this.onInputChange} name="DetourDescription" />




                </ScrollArea>
                </Container>
               {this.state.detourRoute.DetourStart!==null && <Button color='red' onClick={this.deleteDetour}>Delete Detour</Button>}



            </div>
        );
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();
        this.setState({ [name]: value });
        this.props.cpModel.detourRoute[name] = value;
    }
    /*onIsPolyChanged = () => {
        const res = !this.state.isPolyLine;
        this.setState({ isPolyLine: res });
        this.props.routeModel["isPolyLine"] = res;
        this.props.triggerNeedSave();
        this.props.clickFunctions.onPolyLineTick(res);
    }*/
    addWaypoint = () => {
        console.log('Comming ')
        const key = this.state.detourRoute.DetourWaypoints.length;
        const waypointState = (pos, id) => {
            const {DetourWaypoints} = this.state.detourRoute;
            DetourWaypoints.push( [ pos.lat.toFixed(5), pos.lng.toFixed(5) ]);
            this.setState({ DetourWaypoints: DetourWaypoints });
            this.props.cpModel.detourRoute.DetourWaypoints = DetourWaypoints;
        }
        //this.props.cpModel.detourRoute.DetourStart = start
        this.props.clickFunctions.onDetourWaypointPlot(waypointState, key);
        this.props.triggerNeedSave();
    }
    /*removeWaypoint = (id) => {
        const {waypoints} = this.state;
        waypoints.splice(id, 1);
        this.props.clickFunctions.onWaypointSplice(id);
        this.setState({
            waypoints: waypoints
        });
        this.props.routeModel.waypoints = waypoints;
        this.props.triggerNeedSave();
    }*/
   

}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-planning/detour.js